$(document).ready(function() {
  $('#newsletter-popup').click(function() {
    $('.popup').addClass('visible');
  });

  $('.quick-search__clear').click(function() {
   $('.quick-search__overlay').click();
  });
  
  $(".has-children").on('mouseenter', function(event) {
    $('.has-children').removeClass("active");
    $('.no-dropdown').removeClass("active");
    $(this).addClass("active");
    $('.overlay').addClass("active");
  });

  $(".no-dropdown").on('mouseenter', function(event) {
    $(".has-children").removeClass("active");
    $(this).addClass("active");
    $('.overlay').removeClass("active");
  });

  $(".no-dropdown").on('mouseleave', function(event) {
    $(this).removeClass("active");
  });

  $('.variant-selected').click(function() {
    $('.anchor').addClass('hidden');
    $( "#pdpButton").css("display", "block");
  });

  $('#shopify-section-burger-menu .close').click(function() {
    $('.overlay').click();
  });

});

